import React, { useState } from "react";
import "./style.scss";

import { ReactComponent as CoffeBean } from "src/Assets/Icons/coffeeBean.svg";
import { ReactComponent as FingerPrint } from "src/Assets/Icons/fingerPrint.svg";
import { ReactComponent as LogoSvg } from "src/Assets/Icons/logoNicchio.svg";

import bg1 from "src/Assets/Images/bg_graos.jpg";
import bg2 from "src/Assets/Images/bg_graos2.jpg";
import bg3 from "src/Assets/Images/bg_graos3.jpg";

import logo from "src/Assets/Images/logo_Nicchio.png";

import { CustomInput, SubmitButton } from "src/Components";
import { GetLogin } from "../services/auth";
import { isValid } from "../services/utils";
import showToast from "../services/toastyService";

import { useNavigate } from "react-router-dom";

const images = [bg1, bg2, bg3];

export default function Login({ darkMode, setDarkMode }) {
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState({
    user: "admin@nicchiocafe.com",
    pass: "6ZnV@vmH#R",
  });
  const [errDesc, setErrDesc] = useState();

  const [bg] = useState(() => {
    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  });

  const [submitStatus, setSubmitStatus] = useState("");
  function handleLogin() {
    setErrDesc("");
    setSubmitStatus("load");

    if (!isValid(credentials?.user) || !isValid(credentials?.pass)) {
      setTimeout(() => {
        setSubmitStatus("error");
      }, 1000);
      setErrDesc("Credenciais Inválidas");
      return;
    }

    GetLogin(credentials?.user, credentials?.pass)
      .then((res) => {
        if (res) {
          setErrDesc("");
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("userId", JSON.stringify(res.data.user));
          setTimeout(() => {
            //window.location.href = "/home";
            navigate("/home");
          }, 1500);
        } else {
          setTimeout(() => {
            setSubmitStatus("error");
          }, 1000);
        }
      })
      .catch((error) => {
        const msg =
          error?.response?.data?.message ||
          error.message ||
          "Erro desconhecido";
        setErrDesc(msg);
        setTimeout(() => {
          setSubmitStatus("error");
        }, 1000);
      });
  }

  // eslint-disable-next-line no-unused-vars
  function test() {
    localStorage.setItem("token", "fake-token");
    //window.location.href = "/home";
    navigate("/home");
  }

  return (
    <div className="Login" style={{ backgroundImage: `url(${bg})` }}>
      <div className="-fade" />
      <form className="-shadow-medium -absolute-center">
        <LogoSvg className="logo" />

        <h1> Login </h1>

        <CustomInput
          tabIndex={1}
          Style="login"
          Type="text"
          Placeholder="Usuário"
          OnChange={(e) =>
            setCredentials((prev) => ({ ...prev, user: e.target.value.trim() }))
          }
        />
        <CustomInput
          tabIndex={2}
          Style="login"
          Type="password"
          Placeholder="Senha"
          OnChange={(e) =>
            setCredentials((prev) => ({ ...prev, pass: e.target.value.trim() }))
          }
        />
        <SubmitButton
          Type="button"
          Status={submitStatus}
          SetStatus={setSubmitStatus}
          OnClick={() => handleLogin()}
          Icon={FingerPrint}
        >
          {submitStatus === "error"
            ? isValid(errDesc)
              ? errDesc
              : "Erro"
            : "Entrar"}
        </SubmitButton>

        <button
          tabIndex={-1}
          type="button"
          className="theme"
          onClick={() => setDarkMode(!darkMode)}
        >
          <CoffeBean />
          <span
            style={{
              maxWidth: darkMode ? "93%" : "0%",
              maxHeight: darkMode ? "93%" : "0%",
            }}
          >
            <CoffeBean />
          </span>
        </button>
      </form>
    </div>
  );
}
